<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div class="w-100 overflow-hidden p-3">
			<back class="col-lg-9 col-md-6 col-sm-12 col-xs-12 col-sm-push-3 float-right" title="خطای 404" />
			<div class="col-lg-9 col-md-6 col-sm-12 col-xs-12 float-left p-3 border-15 shadow bg-white text-center">
				<img 
					class="w-75" 
					:src="require('../../../assets/img/404.gif')"
				/>
				<p class="text-center bMikhak">
				خطای ۴۰۴ - صفحه با آدرس مورد نظر شما یافت نشد!
				</p>
				<router-link 
					to="/" 
					class="w-100"
				>
				<btn
					class="w-100"
					textClass="w-100 border-hover m-auto text-center"
					type="success"
					
					text="بازگشت به خانه"
				/>
			</router-link>
				
			</div>
			<div class="col-lg-3 col-md-6 col-sm-12 col-xs-12 col-sm-push-9 float-left p-3">
				<leftMenuPublic />
			</div>
		</div>
		<footerPage />
	</div>
</template>

<script>
	import footerPage from  "../../../UI/footer/footer.vue";
	import back from  "../../../UI/back/back.vue";
	import btn from  "../../../UI/button/btn.vue";
	import headMenu from  "../../../menu/headMenu.vue";
	import leftMenuPublic from  "../../../menu/leftMenuPublic.vue";


	export default {
			name: 'teachers_id',
		data(){
			return {
				imgurl: window.imgurl,
				baseurl: window.baseurl,
				flds: [],
				degrees: [],
				category: [],
				location: [],
			}
		},
		components: {
				btn,
				back,
				headMenu,
				footerPage,
				leftMenuPublic,
		},
			props: [],
		mounted(){
			this.$swal.close();
			this.loader();
		},
		methods:{
			// *********************************************************************
			loader(THIS=this){
				window.$.get(this.baseurl+'degrees/hightlights', { }, function(D){
						THIS.flds = D.data;
				}, "json");
			}
				// *********************************************************************
		}
	}
</script>
<style>

</style>
